export enum ERROR_NAMES {
	HTTPError = 'HTTPError',
	StreamedHTTPError = 'StreamedHTTPError',
	NetworkError = 'NetworkError',
}
